import { render, staticRenderFns } from "./FilterTypeNew.vue?vue&type=template&id=6bc9059b"
import script from "./FilterTypeNew.vue?vue&type=script&lang=js"
export * from "./FilterTypeNew.vue?vue&type=script&lang=js"
import style0 from "./FilterTypeNew.vue?vue&type=style&index=0&id=6bc9059b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports